import { render, staticRenderFns } from "./RadioButton.vue?vue&type=template&id=65deda3a&scoped=true"
import script from "./RadioButton.vue?vue&type=script&lang=js"
export * from "./RadioButton.vue?vue&type=script&lang=js"
import style0 from "./RadioButton.vue?vue&type=style&index=0&id=65deda3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65deda3a",
  null
  
)

export default component.exports